"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var upload_exports = {};
__export(upload_exports, {
  uploadMultipart: () => uploadMultipart,
  uploadXhr: () => uploadXhr
});
module.exports = __toCommonJS(upload_exports);
var import_core = require("@hcengineering/core");
async function uploadXhr(upload, options) {
  const signal = options?.signal;
  const onProgress = options?.onProgress;
  if (signal?.aborted === true) {
    throw new Error("Upload aborted");
  }
  const xhr = new XMLHttpRequest();
  const abortHandler = /* @__PURE__ */ __name(() => {
    xhr.abort();
  }, "abortHandler");
  if (signal !== void 0) {
    signal.addEventListener("abort", abortHandler);
  }
  try {
    return await new Promise((resolve, reject) => {
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          onProgress?.({
            loaded: event.loaded,
            total: event.total,
            percentage: Math.round(100 * event.loaded / event.total)
          });
        }
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({
            status: xhr.status,
            responseText: xhr.responseText
          });
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}: ${xhr.statusText}`));
        }
      };
      xhr.onerror = () => {
        reject(new Error("Network error"));
      };
      xhr.onabort = () => {
        reject(new Error("Upload aborted"));
      };
      xhr.ontimeout = () => {
        reject(new Error("Upload timeout"));
      };
      xhr.open(upload.method, upload.url, true);
      for (const key in upload.headers) {
        xhr.setRequestHeader(key, upload.headers[key]);
      }
      xhr.send(upload.body);
    });
  } finally {
    if (signal !== void 0) {
      signal.removeEventListener("abort", abortHandler);
    }
  }
}
__name(uploadXhr, "uploadXhr");
async function uploadMultipart(upload, options) {
  const CHUNK_SIZE = 5 * 1024 * 1024;
  const { url, headers, body } = upload;
  const signal = options?.signal;
  const onProgress = options?.onProgress;
  let uploadId;
  try {
    const { uploadId: uploadId2 } = await multipartUploadCreate(url, { ...headers, "Content-Type": body.type }, signal);
    const parts = [];
    const totalParts = Math.ceil(body.size / CHUNK_SIZE);
    let uploaded = 0;
    for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
      const start = (partNumber - 1) * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, body.size);
      const chunk = body.slice(start, end);
      throwIfAborted(signal);
      const partOptions = {
        signal,
        onProgress: onProgress !== void 0 ? (progress) => {
          const loaded = uploaded + progress.loaded;
          onProgress({
            loaded,
            total: body.size,
            percentage: Math.round(loaded * 100 / body.size)
          });
        } : void 0
      };
      const { etag } = await multipartUploadPart(url, headers, uploadId2, partNumber, chunk, partOptions);
      parts.push({ partNumber, etag });
      uploaded += chunk.size;
    }
    throwIfAborted(signal);
    await multipartUploadComplete(url, headers, uploadId2, parts, signal);
  } catch (err) {
    if (uploadId !== void 0) {
      await multipartUploadAbort(url, headers, uploadId);
    }
    throw err instanceof Error ? err : new Error(String(err));
  }
}
__name(uploadMultipart, "uploadMultipart");
function throwIfAborted(signal) {
  if (signal?.aborted === true) {
    throw new Error("Upload aborted");
  }
}
__name(throwIfAborted, "throwIfAborted");
async function multipartUploadCreate(baseUrl, headers, signal) {
  const response = await fetch(baseUrl, {
    signal,
    method: "POST",
    headers
  });
  if (!response.ok) {
    throw new Error("Failed to initialize multipart upload");
  }
  const { uuid, uploadId } = await response.json();
  return { uuid, uploadId };
}
__name(multipartUploadCreate, "multipartUploadCreate");
async function multipartUploadComplete(baseUrl, headers, uploadId, parts, signal) {
  const url = new URL((0, import_core.concatLink)(baseUrl, "/complete"));
  url.searchParams.set("uploadId", uploadId);
  const response = await fetch(url, {
    signal,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
    body: JSON.stringify({ parts })
  });
  if (!response.ok) {
    throw new Error("Failed to complete multipart upload");
  }
}
__name(multipartUploadComplete, "multipartUploadComplete");
async function multipartUploadPart(baseUrl, headers, uploadId, partNumber, blob, options) {
  const url = new URL((0, import_core.concatLink)(baseUrl, "/part"));
  url.searchParams.set("uploadId", uploadId);
  url.searchParams.set("partNumber", `${partNumber}`);
  const result = await uploadXhr(
    {
      url: url.toString(),
      method: "PUT",
      headers,
      body: blob
    },
    options
  );
  try {
    const response = JSON.parse(result.responseText);
    return { etag: response.etag };
  } catch (err) {
    throw new Error(`Failed to parse response for part ${partNumber}`);
  }
}
__name(multipartUploadPart, "multipartUploadPart");
async function multipartUploadAbort(baseUrl, headers, uploadId) {
  const url = new URL((0, import_core.concatLink)(baseUrl, "/abort"));
  url.searchParams.set("uploadId", uploadId);
  const response = await fetch(url, {
    method: "POST",
    headers
  });
  if (!response.ok) {
    throw new Error("Failed to reject multipart upload");
  }
}
__name(multipartUploadAbort, "multipartUploadAbort");
//# sourceMappingURL=upload.js.map
